export const TABLE_EDITOR_GET_DIMENSIONS_LIST_INIT = 'TABLE_EDITOR_GET_DIMENSIONS_LIST_INIT';
export const TABLE_EDITOR_GET_DIMENSIONS_LIST_SUCCESS = 'TABLE_EDITOR_GET_DIMENSIONS_LIST_SUCCESS';
export const TABLE_EDITOR_GET_DIMENSIONS_LIST_FAILURE = 'TABLE_EDITOR_GET_DIMENSIONS_LIST_FAILURE';
export const TABLE_EDITOR_GET_DIMENSION_INSTANCES_LIST_INIT = 'TABLE_EDITOR_GET_DIMENSION_INSTANCES_LIST_INIT';
export const TABLE_EDITOR_GET_DIMENSION_INSTANCES_LIST_SUCCESS = 'TABLE_EDITOR_GET_DIMENSION_INSTANCES_LIST_SUCCESS';
export const TABLE_EDITOR_GET_DIMENSION_INSTANCES_LIST_FAILURE = 'TABLE_EDITOR_GET_DIMENSION_INSTANCES_LIST_FAILURE';

export const TABLE_EDITOR_SET_FORMULA_TO_EDIT_OBJECT = 'TABLE_EDITOR_SET_FORMULA_TO_EDIT_OBJECT';
export const TABLE_EDITOR_EDIT_FORMULA_TO_EDIT_OBJECT = 'TABLE_EDITOR_EDIT_FORMULA_TO_EDIT_OBJECT';
  
export const TABLE_EDITOR_FORMULA_VALIDATION_INIT = 'TABLE_EDITOR_FORMULA_VALIDATION_INIT';
export const TABLE_EDITOR_FORMULA_VALIDATION_SUCCESS = 'TABLE_EDITOR_FORMULA_VALIDATION_SUCCESS';
export const TABLE_EDITOR_FORMULA_VALIDATION_FAILURE = 'TABLE_EDITOR_FORMULA_VALIDATION_FAILURE';

export const TABLE_EDITOR_RESET = 'TABLE_EDITOR_RESET';


// WEBPACK FOOTER //
// ./source/client/actions/tableEditor/types.js